import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SteplineCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { STEPLINE_CHART } from "../../../../Data/Charts/ApexChart";

const SteplineChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={SteplineCharts} />
        <CardBody>
          <div id="stepline">
            <Chart options={STEPLINE_CHART} series={STEPLINE_CHART.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SteplineChart;
